/**
* @description 將表單輸入轉換成JSON
* @function formToJSON
* @param {object} plainObject 物件
* @param {boolean} mask 遮罩
* @returns {object} obj
*/
$.fn.formToJSON = function (plainObject, mask) {
    var self = $(this);
    mask = mask ? true : false;
    var obj = {};
    let dataArray = [];
    if (self.prop("tagName") === "FORM") {
        dataArray = self.serializeArray();
    }
    else {
        dataArray = self.find("input,select,textarea").serializeArray();
    }
    $(dataArray).each(function () {
        if (this.value.length <= 0 && mask) {
            return;
        }
        if (obj[this.name]) {
            obj[this.name] = obj[this.name] + "@@" + this.value;
        }
        else {
            obj[this.name] = this.value;
        }
    });
    delete obj["__RequestVerificationToken"];
    if ($.isPlainObject(plainObject)) {
        return $.extend(plainObject, obj);
    }
    return obj;
};

/**
 * @description 取得表單控項
 * @function getCtrl
 * @param {string} value 表單控項 name
 * @param {string} name option 表單控項 屬性名稱 預設是name 
 * @returns {object} jquery
 */
$.fn.getCtrl = function (value, name) {
    var attrName = name ? name : "name";
    var arrSelector = value.split(",");
    var i, len, selectors = "";
    for (i = 0, len = arrSelector.length; i < len; i++) {
        //修正等號前方空白 讓新式選擇器能夠作用
        selectors += "[" + attrName + "='" + arrSelector[i] + "'],";
    }
    return $(this).find(selectors.substring(0, selectors.length - 1));
};

$(document).ready(function () {
    // -----------------Initialize Bootstrap tooltips----------------- 
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    // -----------------Get Query String Value from URL----------------- 
    // 導入頁面後改變menu文字

    $.urlParam = function (name) {
        //這串網址裡找問號後面跟等於, 取key(name)的value
        let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        }
        return decodeURI(results[1]) || 0;
    }

    let siteNavLink = $('.site-nav').getCtrl('siteNavLink');
    let pageValue = $.urlParam('target');
    // console.log('Query String = ' + pageValue);

    siteNavLink.removeClass('active');
    $('a[jepun-active-page=' + pageValue + ']').addClass('active');


    // -----------------AOS animate----------------- 
    AOS.init(
        {
            easing: 'ease',  // AOS 動畫的默認緩動
            once: true,  // 是否動畫應該只發生一次 - 向下滾動時
        }
    );
    // -----------------countTo----------------- 
    $('.timer').countTo();

    // -----------------navbar shrink-----------------
    $(window).on('scroll', function () {
        if ($(window).width() > 992) {
            if ($(this).scrollTop() > 74) {
                $('.page-wrapper').addClass('navbar-shrink');
            } else {
                $('.page-wrapper').removeClass('navbar-shrink');
            }
        }
    });

    // -----------------Background Image----------------- 
    $("[data-background").each(function () {
        $(this).css("background-image", "url( " + $(this).attr("data-background") + "  )");
    });

    // -----------------GoTop----------------- 
    var wh, h, sHeight;

    //自適應屏幕尺寸
    function setSizes() {
        wh = $(window).height();
        h = $('body').height();
        sHeight = h - wh;//(document height) - (window height)
        //文檔總長度減去窗口本身的高度（因為文檔將滾動，直到文檔底部到達窗口底部）
    }

    setSizes();

    //滾動位置計算
    $(window).on('scroll', function () {
        // 設置變量（百分比的縮寫）
        var perc = Math.max(0, Math.min(1, $(window).scrollTop() / sHeight));
        updateProgress(perc);
    }).on('resize', function () {
        //調整窗口大小時重新觸發
        setSizes();
        $(window).trigger('scroll');
    });

    function updateProgress(perc) {
        var circle_offset = 76 * perc;
        $('.animated-circle').css({
            "stroke-dashoffset": 76 - circle_offset
        });

        //水平進度條
        $('.progress-indicator-2').css({ width: perc * 100 + '%' });
    }

    var offset = 50;
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > offset) {
            $('.progress-indicator').addClass('progress-active');
        } else {
            $('.progress-indicator').removeClass('progress-active');
        }
    });
    $('.top-icon').on('click', function (event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, '3000');
        return false;
    })

});